import imageMale from 'assets/img/icons/avatar-male.svg';
import AIUtils from 'services/AIUtils';
import { Admin } from 'generated/api';

class AdminUtils {
  getAssistantUser(admins: Record<string, Admin>): Admin | undefined {
    return Object.values(admins).find((a) => a.name === AIUtils.getAssistantName());
  }

  getName(admin: Admin | undefined): string {
    let error = 'Unknown Name';

    if (!admin) return error;

    let name = '';

    if (admin.name !== undefined) name = admin.name;

    name = name.trim();

    if (name === '') name = error;

    return name;
  }

  getPhotoUrls(admin: Admin | undefined): [string | undefined, string] {
    return [admin?.photo, imageMale];
  }
}

export default new AdminUtils();
